import { useEffect, useContext } from "react";
import { UserContext } from "../contexts/UserContext"
import { useNavigate } from 'react-router-dom';

const Logout = () =>
{
    const {logout} = useContext(UserContext);
    const navigate = useNavigate();

    useEffect(() => {
        logout();
        navigate('/login');
    }, []);
}

export default Logout;